module.exports = __webpack_public_path__ + "static/media/port1.e2413e66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/port1.jpg
// module id = 5835
// module chunks = 0